export enum BuilderLeftEnum {
  Tree = 'Tree',
  ChangesToCommit = 'ChangesToCommit',
  ChangesToPush = 'ChangesToPush',
  Info = 'Info'
}
